export default function UndoIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M312.261 865.609q-16.957 0-28.283-11.326T272.652 826q0-16.957 11.326-28.283t28.283-11.326h259q66.043 0 113.717-43.674Q732.652 699.043 732.652 634t-47.674-108.717q-47.674-43.674-113.717-43.674H299.436l76.608 76.608Q387.87 570.043 387.87 586t-11.826 27.783q-11.826 11.826-27.783 11.826t-27.783-11.826l-144-144q-6.13-6.131-8.978-13.109T164.652 442q0-7.696 2.848-14.674t8.978-13.109l144-144q11.826-11.826 27.783-11.826t27.783 11.826Q387.87 282.043 387.87 298t-11.826 27.783l-76.608 76.608h270.825q98.957 0 170.283 67.109T811.87 634q0 97.391-71.326 164.5t-170.283 67.109h-258Z"
      />
    </svg>
  );
}
